const isInbound = type => type === 'inbound';
const isOutbound = type => type === 'outbound';

const identifyCity = cityToBeMatched => city =>
  city.toLowerCase() === cityToBeMatched;

const isDestinationToArrivalAndViceVersa = (isArrival, isDestination) => (departure, arrival) => { 
  if (
    (isArrival(departure) && isDestination(arrival)) ||
    (isArrival(arrival) && isDestination(departure))
  ) { 
    return true;
  }

  return false;
}

const isLukla = identifyCity('lukla');
const isKtm = identifyCity('kathmandu');
const isRamechhap = identifyCity('ramechhap');
const isPokhara = identifyCity('pokhara');
const isJomsom = identifyCity('jomsom');

const isRchToLukla = isDestinationToArrivalAndViceVersa(isRamechhap, isLukla);
const isKtmToLukla = isDestinationToArrivalAndViceVersa(isKtm, isLukla);
const isPkrToJomsom = isDestinationToArrivalAndViceVersa(isPokhara, isJomsom);

function getTextForRchFlights(departure, arrival) { 
  if (isRamechhap(departure) && isLukla(arrival)) return 'Includes KTM-RCH transport';
  if (isLukla(departure) && isRamechhap(arrival)) return 'Includes RCH-KTM transport';
}

const appendRchForKtmToLuklaFlights = (departure, arrival) =>
  isLukla(departure) ? 'Fly to KTM' :  `Fly from KTM`

export {
  appendRchForKtmToLuklaFlights,
  isKtmToLukla,
  isRchToLukla,
  isPkrToJomsom,
  getTextForRchFlights,
  isInbound,
  isOutbound,
};



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchResults/identifyFlights.js